// extracted by mini-css-extract-plugin
export default {"wrapper":"TVftA","label":"NlP9K"};